/** A 1Click delivery's stage; deposits and withdrawals populate it differently. */
export const XCHAIN_STAGES = ["waiting", "pending", "delivered", "failed"] as const;
export type XchainStage = (typeof XCHAIN_STAGES)[number];
